import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const ToucshcreenPage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-center">
    <Seo title="TOUCHSCREEN POS MESIN KASIR LAYAR SENTUH TOUCHSCREEN TERBARU" />
    <h2><strong>TOUCHSCREEN POS</strong></h2>
    <p>
Mesin kasir modern layar sentuh persembahan dari ASUS technology untuk anda gunakan,kompleks dan lengkap dengan integrasi software apikasi kasir program restoran hingga hardware alat kasir yang bisa dipilih sesuai kebutuhan, free instalasi dan setting siap pakai..!!
	</p>
  <div className="embed-responsive embed-responsive-16by9">
<iframe title="all in one pos touchscreen mesin kasir layar sentuh terbaru" width="560" height="315" src="https://www.youtube.com/embed/NLxDbnyQ4r4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>
Elegan desain dan mewah dengan balutan casing menawan fashionable menjadikan terbaik digunakan , era mesin kasir terbaru modern kini siap untuk digunakan, dukungan aplikasi yang bebas dipilih sesuai dengan kebutuhan menjadikan nya memudahkan dalam mengakomodasi segala kebutuhan transaksi hingga rangkuman pembukuan usaha dan bisnis.
</p>
<a href="https://mesinkasir.github.io/e-catalog/TOUCHSCREEN%20POS.pdf" target="blank" className="button">Download</a>
<p>Download e-Catalog untuk cek harga dan pilihan paket.</p>
<p>Touchscreen layar sentuh yang super sensitif dan berkemampauan digunakan dengan barcode system maupun full touchscreen metode menjadikan nya lebih baik untuk digunakan pada usaha retail shop toko modern hingga restoran cafe rumah makan mu.
</p>
<p>Touchscreen pos mesin kasir modern terbaik untuk usaha mu.</p>
<Link to="/security" className="button button-outline float-left">&larr; Alarm</Link> <Link to="/hybrid" className="button button-outline float-right">Tablet POS &rarr;</Link>
</div>

	</div>
  </Layout>
)

export default ToucshcreenPage